module.exports = __webpack_public_path__ + "img/image5.86af23f2.jpeg";